export default __webpack_public_path__ + "static/bg-report-54376b0d41c27646304bdb0cb7484dcd.png";